import useCurrencySymbol from './useCurrencySymbol';

function useFormattedCurrency(value: string | number) {
  const symbol = useCurrencySymbol();

  return `${symbol} ${parseFloat(value.toString()).toFixed(2).replace('.', ',')}`;
}

export default useFormattedCurrency;
